import * as React from 'react';
import { VStack, type StackProps } from './stack';

/**
 * Project FormCard.
 *
 * The white panel the onboarding form fields sit in (prototype `.card` plus
 * `.form-card`): an 18px radius, 22px padding, an 18px gap between field
 * groups and a hairline border, sitting on the Feather page. Figma draws it
 * borderless at 20px/20px; the prototype is the layout authority.
 *
 * Separate from the generic `Card` wrapper, which is an unopinionated
 * pass-through used by unrelated consumers.
 */
export type FormCardProps = StackProps;

export const FormCard = React.forwardRef<HTMLDivElement, FormCardProps>(
  ({ children, ...rest }, ref) => (
    <VStack
      ref={ref}
      align="stretch"
      bg="white"
      borderColor="fieldBorder.200"
      borderWidth="1px"
      gap="18px"
      p="22px"
      rounded="panel"
      w="100%"
      {...rest}
    >
      {children}
    </VStack>
  )
);
FormCard.displayName = 'FormCard';
